import { ROTA_APIS } from "@/api_framework/api_config";
import { IRotaManagementRotaCreatePropsData, IRotaManagementRotaCreateResponse } from "@/api_framework/api_modals/Rota";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setRotaerrorIds } from "@/app_redux/reducers/slices/auth/rota_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

AxiosCurlirize(axios, () => {});
type ROTAErrorType = {
  status: boolean;
  message: string;
  data: any | null;
};

export type RotaCreationReturnType = {
  status: boolean;
  message: string;
};

export const useRotaCreateAPI = () => {
  const configuration = useConfiguration();
  const [rotaCreationError, setRotaCreationError] = useState<ROTAErrorType>(null);
  const [isCreated, setIsCreated] = useState<"CREATED" | "ERROR" | null>(null);

  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const catchError = (e: AxiosError) => {
    if (e.response.status === 500) {
      setRotaCreationError({
        data: null,
        status: false,
        message: "Server Error 500",
      });
    }
    setRotaCreationError(e.response.data as ROTAErrorType);
    setIsCreated("ERROR");
  };

  const execute = useCallback(
    async (filterParams: IRotaManagementRotaCreatePropsData) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: RotaCreationReturnType = await axios
          .post(ROTA_APIS?.ROTA_CREATE_API?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IRotaManagementRotaCreateResponse>) => {
            if (res.data.status === true) {
              toast.success("Rota has been created ");
              setIsCreated("CREATED");
              return { status: true, message: "ROTA_CREATED" };
            } else {
              return { status: false, message: "ROTA_NOT_CREATED" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            const vv = e.response.data as any;
            dispatch(setRotaerrorIds({ data: vv }));
            captureError(e);
            catchError(e);
            return { status: false, message: vv };
          });
        return response;
      } catch (e: any) {
        const vv = e.response.data as any;

        toast.error("Server Error: " + e.message);
        setIsCreated("ERROR");
        return { status: false, message: vv.message };
      }
    },
    [dispatch],
  );
  return { isCreated, rotaCreationError, execute };
};
